<template>
  <div class="horizon">
    <div class="lefttree">
      <div class="left_title_bg">
        <div class="label_div"></div>
        <!-- <div class="flex1 label_tv">服务管理
        </div> -->
        <i class="el-icon-plus add_icon" @click="addCata" />
      </div>
      <el-tree
        class="tree"
        :data="Treedata"
        node-key="id"
        :expand-on-click-node="false"
        :default-expanded-keys="firstClassNodeIds"
        @node-click="handleNodeClick"
      >
        <span class="custom-tree-nodes horizon" slot-scope="{ node, data }">
          <div class="title-label">{{ node.label }}</div>
          <!-- 判断是否是类别 -->
          <!-- <span v-if="node.level == 1">
            <i class="el-icon-plus span_icon color_blue" @click="() => addPj(node,data)"/>
            <i class="el-icon-edit-outline span_icon color_blue" @click="() => editPj(node,data)"/>
            <i class="el-icon-delete span_icon color_red" @click="() => rmPj(node,data)"/>
          </span>-->
        </span>
      </el-tree>
    </div>
    <div class="flex1 marleft20">
      <div class="right_title_bg">
        <div class="label_div"></div>
        <div class="flex1 label_tv center_tv">服务管理列表</div>
      </div>
      <div class="table-content">
        <table-base
          :tableData="dataList"
          @page-change="pageChange"
          @currentpage-change="clickChange"
          :len="tabelLen"
          :pageNum="pageNum"
          :pageSize="pageSize"
          :pageName="AcurrentPage"
          :titleStyle="titleStyle"
        >
          <template slot="table">
            <el-table-column prop="firstName" label="服务类别" align="center"></el-table-column>
            <el-table-column prop="firstDesc" label="服务类别描述" align="center"></el-table-column>
            <el-table-column prop="name" label="服务小项" align="center"></el-table-column>
            <el-table-column prop="desc" label="服务小项描述" align="center"></el-table-column>
          </template>
        </table-base>
      </div>
    </div>

    <!-- 新增和修改服务类别的dialog模态框-->
    <el-dialog
      :title="serviceCategory.title"
      width="35%"
      :visible.sync="dialogVisibleForm"
      :close-on-click-modal="false"
      @close="closeServiceCategoryFormDialog"
    >
      <el-form
        :model="serviceCategoryForm"
        label-width="120px"
        :rules="serviceCategoryFormRules"
        ref="serviceCategoryForm"
        label-position="right"
      >
        <el-form-item :label="serviceCategory.serviceType" prop="name">
          <el-input
            v-model.trim="serviceCategoryForm.name"
            auto-complete="off"
            :placeholder="serviceCategory.enterServiceType"
            style="width:80%;"
            :disabled="this.codeType=='default'"
          ></el-input>
        </el-form-item>
        <el-form-item :label="serviceCategory.ServiceDescription" prop="description">
          <el-input
            v-model.trim="serviceCategoryForm.description"
            type="textarea"
            :rows="4"
            auto-complete="off"
            :placeholder="serviceCategory.enterServiceDescription"
            style="width:80%;"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleForm = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitForm">确定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>
<script>
// 服务项目
import TableBase from "@/components/common-table";
export default {
  components: { TableBase },
  data() {
    return {
      pageRequest: { pageNum: 1, pageSize: 10 },
      groupId: "",
      Treedata: [
        {
          id: 100,
          label: "助餐",
          children: [
            {
              id: 1,
              label: "一级 1"
            },
            {
              id: 2,
              label: "一级 2"
            }
          ]
        },
        {
          id: 200,
          label: "助洁",
          children: [
            {
              id: 3,
              label: "一级 1"
            },
            {
              id: 4,
              label: "一级 2"
            }
          ]
        }
      ],
      treeIndex: 0,
      firstClassNodeIds: [],
      dialogVisibleForm: false,
      serviceCategory: {
  serviceType: "服务类别",
  serviceItem: "服务项目",
  basicInfo: "基本信息",
  addServive: "新增服务类别",
  editService: "修改服务类别",
  addServiceItem: "新增服务项目",
  editServiceItem: "修改服务项目",
  serviceName: "服务名称：",
  categoryDescription: "类别描述：",
  itemList: "项目列表",
  serviceCategory: "序号",
  projectName: "项目名称",
  itemSmallClass: "项目小类",
  projectCost: "项目费用",
  chargeMethod: "收费方式",
  timeRequired: "所需时间",
  projectIntroduction: "项目介绍",
  enterServiceType: "请输入服务类别",
  ServiceDescription: "类别描述",
  enterServiceDescription: "请输入服务描述",
  addItem: "新增项目",
  editItem: "修改项目",
  belongCategory: "所属类别",
  enterBelongCategory: "请选择所属类别",
  enterItemSmallClass: "请输入项目小类",
  enterProjectCost: "请输入费用项目",
  enterTimeRequired: "请输入所属时间",
  enterProjectIntroduction: "请输入项目介绍",
  notEmpty: "不能为空"
}, //引入 lang 里面的字符串资源
      serviceCategoryForm: {
        name: "",
        description: "",
        firstLevelId: "",
        id: ""
      },
      codeType: "", //默认的服务名称为default时 不能被修改
      serviceCategoryFormRules: {
        //验证的匹配规则
        name: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          },
          { min: 1, max: 10, message: "请输入1到10个字符" }
        ],
        description: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          },
          { min: 1, max: 30, message: "请输入1到30个字符" }
        ]
      },
      size: "medium",
      serverPjId: "",
      dataList: [],
      tableloading: false,
      tabelLen: 0,
      pageNum: 1,
      pageSize: 5,
      AcurrentPage: "employee-page",
      titleStyle: "background: #B3E3F5; font-size:15px;"
    };
  },
  methods: {
    handleNodeClick(data, node, dom) {
      let dataList = [];
      if (data.children) {
        data.children.forEach(child => {
          dataList.push({
            firstName: data.label,
            firstDesc: data.description,
            name: child.label,
            desc: child.desc,
            id: child.id,
            firstLevelId: child.firstLevelId
          });
        });
        this.dataList = dataList;
      }
      // if (node.level == 1) {
      //   for (var i = 0; i < this.Treedata.length; i++) {
      //     if (data.id == this.Treedata[i].id) {
      //       this.treeIndex = i;
      //       var dataList = [];
      //       console.log(this.Treedata[i].children);
      //       for (var j = 0; j < this.Treedata[i].children.length; j++) {
      //         dataList.push({
      //           firstName: this.Treedata[i].label,
      //           firstDesc: this.Treedata[i].description,
      //           name: this.Treedata[i].children[j].label,
      //           desc: this.Treedata[i].children[j].desc,
      //           id: this.Treedata[i].children[j].id,
      //           firstLevelId: this.Treedata[i].children[j].firstLevelId
      //         });
      //       }
      //       this.dataList = dataList;
      //       break;
      //     }
      //   }
      // }
    },
    /* 
      关闭新增和修改的dialog清除验证
    */
    closeServiceCategoryFormDialog() {
      this.$refs.serviceCategoryForm.resetFields(); //移除校验结果并重置字段值
    },
    //提交添加类别
    submitForm() {
      this.$refs.serviceCategoryForm.validate(valid => {
        if (valid) {
          let url = "";
          let params = new Object();
          params.groupId = Number(sessionStorage.getItem("groupId"));
          //公共的数据
          if (this.serviceCategory.title == "新增服务类别") {
            params.name = this.serviceCategoryForm.name;
            params.description = this.serviceCategoryForm.description;
            url = "omc/service/addFirstLevel";
          } else if (this.serviceCategory.title == "修改服务类别") {
            params.name = this.serviceCategoryForm.name;
            params.id = this.serviceCategoryForm.id;
            params.description = this.serviceCategoryForm.description;
            url = "omc/service/updateFirstLevel";
          } else if (this.serviceCategory.title == "新增服务项目") {
            params.firstLevelId = this.serverPjId;
            params.secondLevelName = this.serviceCategoryForm.name;
            params.remark = this.serviceCategoryForm.description;
            url = "omc/service/addSecondLevel";
          } else if (this.serviceCategory.title == "修改服务项目") {
            params.id = this.serviceCategoryForm.id;
            params.remark = this.serviceCategoryForm.description;
            params.secondLevelName = this.serviceCategoryForm.name;
            url = "omc/service/updateSecondLevel";
          }
          this.$postJson(url, params).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.operation = true; //初始化数据
              this.dialogVisibleForm = false; //初始化数据
              this.$message({ message: res.message, type: "success" });
              this.getServiceTree();
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          });
        }
      });
    },
    addCata() {
      this.$nextTick(() => {
        if (this.$refs.serviceCategoryForm != undefined) {
          this.$refs.serviceCategoryForm.resetFields(); //移除校验结果并重置字段值
        }
      });
      this.serviceCategory.title = "新增服务类别";
      this.dialogVisibleForm = true;
      this.serviceCategoryForm = {
        name: "",
        description: "",
        firstLevelId: "",
        id: ""
      };
      this.codeType = "";
    },
    //添加二级项目
    addPj(node, data) {
      console.log(node);
      console.log(data);
      this.$nextTick(() => {
        if (this.$refs.serviceCategoryForm != undefined) {
          this.$refs.serviceCategoryForm.resetFields(); //移除校验结果并重置字段值
        }
      });
      this.dialogVisibleForm = true;
      this.serverPjId = data.id;
      this.serviceCategoryForm = {
        name: "",
        description: "",
        firstLevelId: ""
      };
      this.codeType = "";
      this.serviceCategory = {
        serviceType: "服务项目",
        title: "新增服务项目",
        ServiceDescription: "项目描述"
      };
    },
    //编辑类别
    editPj(node, data) {
      console.log(node);
      console.log(data);
      this.$nextTick(() => {
        if (this.$refs.serviceCategoryForm != undefined) {
          this.$refs.serviceCategoryForm.resetFields(); //移除校验结果并重置字段值
        }
      });
      this.serviceCategory.title = "修改服务类别";
      this.dialogVisibleForm = true;
      this.serviceCategoryForm = {
        name: data.label,
        description: data.description,
        id: data.id
      };
    },
    //删除类别
    rmPj(node, data) {
      this.$confirm("此操作将永久删除该类别, 是否继续?", "提示", {
        confirmButtonText: 确定,
        cancelButtonText: 取消,
        type: "warning"
      })
        .then(() => {
          let firstLevelId = data.id;
          this.$postForm(`omc/service/deleteFirstLevel/${firstLevelId}`).then(
            res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.getServiceTree();
              } else {
                this.$message({
                  type: "error",
                  message: "" + res.message
                });
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    pageChange(val) {
      console.log(val);
      this.dataList = []; //初始化避免累加
      this.pageRequest.pageNum = val;
    },
    itempjedit(index, row) {
      console.log(row);
      this.$nextTick(() => {
        if (this.$refs.serviceCategoryForm != undefined) {
          this.$refs.serviceCategoryForm.resetFields(); //移除校验结果并重置字段值
        }
      });
      this.dialogVisibleForm = true;
      this.serviceCategoryForm = {
        name: row.name,
        description: row.desc,
        firstLevelId: row.firstLevelId,
        id: row.id
      };
      this.codeType = "";
      this.serviceCategory = {
        serviceType: "服务项目",
        title: "修改服务项目",
        ServiceDescription: "项目描述"
      };
    },
    itempjrm(index, row) {
      console.log(row);
      this.$confirm("此操作将永久删除该项目, 是否继续?", "提示", {
        confirmButtonText: 确定,
        cancelButtonText: 取消,
        type: "warning"
      })
        .then(() => {
          let firstLevelId = row.id;
          this.$postForm(`omc/service/deleteSecondLevel/${firstLevelId}`).then(
            res => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.getServiceTree();
              } else {
                this.$message({
                  type: "error",
                  message: "" + res.message
                });
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    clickChange(val) {
      console.log(val);
    },
    //获取树状的
    getServiceTree() {
      //omc/service/listService/
      //左侧的tree
      this.$postJson("omc/service/listService", {
        groupId: this.groupId
      }).then(res => {
        console.log(res.result, "listservice");
        let Treedata = [];
        let dataList = [];
        res.result.forEach(firstLevel => {
          // if (firstLevel.remark == "default") {
            let first = {
              label: "",
              children: [],
              label: firstLevel.name,
              description: firstLevel.description
            };
            firstLevel.serviceSecondLevelList.forEach(secondLevel => {
              dataList.push({
                firstName: firstLevel.name,
                firstDesc: firstLevel.description,
                name: secondLevel.secondLevelName,
                desc: secondLevel.remark,
                id: secondLevel.id,
                firstLevelId: secondLevel.firstLevelId
              });
              first.label = firstLevel.name;
              first.children.push({
                id: secondLevel.id,
                firstLevelId: secondLevel.firstLevelId,
                label: secondLevel.secondLevelName,
                desc: secondLevel.remark
              });
            });
            Treedata.push(first);
          // }
        });
        this.Treedata = Treedata;
        this.dataList = dataList;
        // for (var i = 0; i < res.result.length; i++) {
        //   var children = [];
        //   if (res.result[i] != null) {
        //     console.log(this.treeIndex);
        //     if (this.treeIndex == i) {
        //       var dataList = [];
        //       for (
        //         var j = 0;
        //         j < res.result[i].serviceSecondLevelList.length;
        //         j++
        //       ) {
        //         dataList.push({
        //           firstName: res.result[i].name,
        //           firstDesc: res.result[i].description,
        //           name: res.result[i].serviceSecondLevelList[j].secondLevelName,
        //           desc: res.result[i].serviceSecondLevelList[j].remark,
        //           id: res.result[i].serviceSecondLevelList[j].id,
        //           firstLevelId:
        //             res.result[i].serviceSecondLevelList[j].firstLevelId
        //         });
        //       }
        //       this.dataList = dataList;
        //     }
        //     for (
        //       var j = 0;
        //       j < res.result[i].serviceSecondLevelList.length;
        //       j++
        //     ) {
        //       children.push({
        //         id: res.result[i].serviceSecondLevelList[j].id,
        //         firstLevelId:
        //           res.result[i].serviceSecondLevelList[j].firstLevelId,
        //         label: res.result[i].serviceSecondLevelList[j].secondLevelName,
        //         desc: res.result[i].serviceSecondLevelList[j].remark
        //       });
        //     }
        //     this.dataList = dataList;
        //   }
        //   for (
        //     var j = 0;
        //     j < res.result[i].serviceSecondLevelList.length;
        //     j++
        //   ) {
        //     children.push({
        //       id: res.result[i].serviceSecondLevelList[j].id,
        //       firstLevelId:
        //         res.result[i].serviceSecondLevelList[j].firstLevelId,
        //       label: res.result[i].serviceSecondLevelList[j].secondLevelName,
        //       desc: res.result[i].serviceSecondLevelList[j].remark
        //     });
        //   }
        // }
        // console.log(this.dataList, "datalist");
        // Treedata.push({
        //   id: res.result[i].id,
        //   label: res.result[i].name,
        //   description: res.result[i].description,
        //   children: children
        // });

        // this.Treedata = Treedata;
      });
    }
  },
  created() {
    this.groupId = sessionStorage.getItem("groupId");
    this.getServiceTree();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.horizon {
  display: flex;
  flex-direction: row;
}
.flex1 {
  flex: 1;
}
.marleft20 {
  margin-left: 20px;
}
.lefttree {
  width: 220px;
}
.center_tv {
  text-align: center;
}
.label_div {
  background: #0b80c0;
  width: 6px;
  height: 24px;
  margin-left: 12px;
  margin-right: 8px;
}
.left_title_bg {
  background: #b3e3f5;
  width: 220px;
  padding: 12px 0px;
  display: flex;
  flex-direction: row;
}
.right_title_bg {
  background: #b3e3f5;
  padding: 12px 0px;
  display: flex;
  flex-direction: row;
}
.label_tv {
  font-size: 16px;
  color: gray;
}
.add_icon {
  color: #0b80c0;
  font-size: 20px;
  margin-right: 12px;
  font-weight: bold;
  margin-top: 3px;
}
.title-label {
  width: 120px;
}
.span_icon {
  font-size: 16px;
  margin-right: 5px;
}
.item_icon {
  font-size: 20px;
  margin-right: 5px;
}
.color_blue {
  color: #0b80c0;
}
.color_red {
  color: #ff855f;
}
.tree {
  margin-top: 10px;
}
.table-content {
  margin-top: 10px;
}
</style>
